import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_edcity extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }
  addProductToSchoolByYear(product_code, school_code, school_year, school_contact_name, school_contact_mobile, school_contact_email, passcode){
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/prod/addProductToSchoolByYear.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('product_code', product_code);
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('school_year', school_year);
    bodyFormData.set('school_contact_name', school_contact_name);
    bodyFormData.set('school_contact_mobile', school_contact_mobile);
    bodyFormData.set('school_contact_email', school_contact_email);
    bodyFormData.set('passcode', passcode);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  listProductSchoolByYear(school_year, passcode) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/prod/listProductSchoolByYear.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_year: school_year,
          passcode: passcode,
        }
      }).then(response => response.data);
    }
  }
  getSchoolStudentsBySchoolCode(school_code, school_year, passcode) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/prod/getSchoolStudentsBySchoolCode.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          school_year: school_year,
          passcode: passcode,
        }
      }).then(response => response.data);
    }
  }
  addUpdateSchoolStudentsBySchoolCode(school_code, expiry_date, passcode, file) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/addUpdateSchoolStudentsBySchoolCode.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('expiry_date', expiry_date);
    bodyFormData.set('passcode', passcode);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  
  getSchoolTeachersBySchoolCode(school_code, passcode) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/prod/getSchoolTeachersBySchoolCode.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          passcode: passcode,
        }
      }).then(response => response.data);
    }
  }

  addUpdateSchoolTeachersBySchoolCode(school_code, expiry_date, passcode, file) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/edcity/prod/addUpdateSchoolTeachersBySchoolCode.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('expiry_date', expiry_date);
    bodyFormData.set('passcode', passcode);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
}